module.exports = __webpack_public_path__ + "static/media/instagram.1b7cb792.svg";